import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import { dataAcareacoesReducer } from "../reducers";
import { InitialState } from "./models";

const initialState: InitialState = {
  dataAcareacoes: {
    data: [],
    requestGetParams: {
      status: "",
      pagina: 1,
      itensPorPagina: 15,
    },
    pagination: {
      page: 1,
      rowsPerPage: 15,
      totalItems: 0,
      totalPages: 0,
    },
    isLoading: false,
  },
  showFiltersForm: false,
  filtersForm: {},
  activeSubtab: "",
  configTabs: {
    tabInView: 0,
    tabs: [
      {
        title: "Tratativas",
        index: 0,
        active: true,
        name: "tratativas",
      },
    ],
  },
};

const acareacoesSlice = createSlice({
  name: "acareacoesApp/acareacoes",
  initialState,
  reducers: {
    changeTab: (state, action) => {
      state.configTabs.tabInView = action.payload;
      if (action.payload === 0) state.configTabs.tabs[1].active = false;
    },
    setActiveSubtabReducer: (state, action) => {
      state.activeSubtab = action.payload;
    },
    clearDataAcareacoes: (state) => {
      state.dataAcareacoes.data = [];
      state.dataAcareacoes.requestGetParams = {
        status: "",
        pagina: 1,
        itensPorPagina: 15,
      };
      state.dataAcareacoes.pagination = {
        page: 1,
        rowsPerPage: 15,
        totalItems: 0,
        totalPages: 0,
      };
    },
    clearRequestGetParams: (state) => {
      state.dataAcareacoes.requestGetParams = {
        status: "",
        pagina: 1,
        itensPorPagina: 15,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Actions.getDataAcareacoes.pending, (state) => {
      state.dataAcareacoes.isLoading = true;
    });
    builder.addCase(Actions.getDataAcareacoes.rejected, (state) => {
      state.dataAcareacoes.isLoading = false;
    });
    builder.addCase(Actions.getDataAcareacoes.fulfilled, dataAcareacoesReducer);
    builder.addCase(
      Actions.getVariableShowFilters.fulfilled,
      (state, action) => {
        state.showFiltersForm = action.payload === "S" ? true : false;
      }
    );
  },
});

export const {
  changeTab,
  clearDataAcareacoes,
  clearRequestGetParams,
  setActiveSubtabReducer,
} = acareacoesSlice.actions;

export default acareacoesSlice.reducer;
